import React, { useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import {
    settings, getResponse, sendMessageCloseCurrentWindow, getLanguageObj, getError, setDataTableLanguaje
} from '../../helpers/UtilsHelper';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import TableIndex from '../main/TableIndex';

const { icons, images, labels } = settings;

const currentMethod = 'ViewAllRates - function';

export default function ViewAllRates({
    processValues = {},
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    const { $, auth, showModal, setShowModal, dtId, rateViews } = processValues;
    const isMount = useRef(true);

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            response = setDataTable({ subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning) {
                setShowModal(false);
                return;
            }

            $(`#${dtId}`).DataTable().rows.add(rateViews).draw(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!response?.isSuccess || response?.isWarning) {
                setShowModal(false);
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    };

    const setDataTable = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            const fontSize_ = 'font-size:14px';

            $(`#${dtId}`).DataTable({
                destroy: true,
                data: [],
                order: [[2, 'desc']],
                columns: [
                    {
                        title: labels?.rate?.[languageObj?.id],
                        width: '50%',
                        orderable: false,
                        render: function (data, type, row) {
                            return `<span style='${fontSize_}'>${data}</span>`;
                        },
                    },
                    {
                        title: labels?.registry?.[languageObj?.id],
                        width: '50%',
                        orderable: false,
                        render: function (data, type, row) {
                            return `<span style='${fontSize_}'>${data}</span>`;
                        },
                    },
                    {
                        title: labels?.registry?.[languageObj?.id],
                        width: '0%',
                        orderable: false,
                        visible: false,
                        searchable: false,
                        render: function (data, type, row) {
                            return `<span style='${fontSize_}'>${data}</span>`;
                        },
                    },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                language: setDataTableLanguaje({ code: languageObj?.id }),
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
                //}).buttons().container().appendTo(`#${dtId}_wrapper .col-md-6:eq(0)`);
            });

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Modal backdrop='static' onHide={() => setShowModal(false)} show={showModal} contentClassName='border-0 shadow-lg login-card'>
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='rateLogo' src={images?.rateLogo} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.viewAllRates?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className={`badge badge-pill py-1 px-2 text-uppercase badge-info`}
                            style={settings?.html?.badges?.micro}>
                            {labels?.viewAllRates?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body className='px-4 pt-2 pb-4'>
                <TableIndex tableId={dtId} languageObj={languageObj} />
            </Modal.Body>

            <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                <div className='d-flex justify-content-center w-100'>
                    <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                        data-title={labels?.close?.[languageObj?.id]}
                        type='button'
                        onClick={() => setShowModal(false)}>
                        <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} /> {labels?.close?.[languageObj?.id]}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}